import { type ReactNode } from 'react'

import { cn } from '~/utils/tailwind-utils'

export const PageLayoutTitle = ({
  title,
  actionButtons,
}: {
  title?: ReactNode | string
  actionButtons?: ReactNode
}) => {
  if (!title) return null

  return (
    <div className="flex min-h-11 w-full items-center justify-between gap-2">
      <h1 className={cn(actionButtons && 'line-clamp-1 flex-1')}>{title}</h1>
      {actionButtons && (
        <div className="flex items-center gap-2">{actionButtons}</div>
      )}
    </div>
  )
}
